export default __webpack_public_path__ + "static/media/logo.f45fd557.png";